import styles from './style.module.scss';

interface Props {
    kycStatus: string;
    avatar: string | null;
};

export default function Identifying(props: Props) {
    const { avatar, kycStatus } = props;

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Personal photo</span>
                </div>
                <div className={styles.content_main}>
                    <div className={styles.content_main_avatar}>
                        <img src={avatar || ''} alt='' />
                    </div>
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>ID</span>
                </div>
                <div className={styles.content_main}>
                    <span
                        className={styles.content_main_status}
                        data-kyc-status={kycStatus}
                    >
                        {kycStatus === 'approved' && 'ID verified'}
                        {kycStatus === 'notApproved' && 'ID not verified'}
                    </span>
                </div>
            </div>
        </div>
    )
}
